import React from 'react';
import './Cover.css';
import { ReactTyped } from 'react-typed';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCloudDownloadAlt, faFileContract } from '@fortawesome/free-solid-svg-icons';

const Cover = () => {
    return (
        <section id="cover" className="cover">
            <div className="container text-center">
                <h1 className="my-auto">Hi, my name is <span className="my_name">Jakia</span></h1>
                <h2 className="py-3">
                    I'm a <ReactTyped
                        className="typed__text"
                        strings={['Full Stack web developer ', 'Frontend web developer ', 'Backend web developer ']}
                        typeSpeed={40}
                        backSpeed={60}
                        loop
                    />
                </h2>

                <div className="btn__group">
                    <a style={{ textDecoration: 'none' }} href="https://docs.google.com/document/d/11Dff_8M9k_OKW1WAY1-F6OlSbxIeIsITAfRa_mUFSmM/edit?usp=sharing" className="cv__btn mt-3 me-3" download><FontAwesomeIcon icon={faCloudDownloadAlt} /> Download Resume</a>
                    <a href="#contact" type="button" className="cv__btn mt-3 ml-4"><FontAwesomeIcon icon={faFileContract} /> Contact me</a>
                </div>
            </div>
        </section>
    );
};

export default Cover;